import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Params, ComparativeAnalysisFilterValues } from './type';

type InitialState = {
  isLoading: boolean;
  transits: any | null;
  error: any;
  filterValues: Partial<ComparativeAnalysisFilterValues> | null;
  isExportLoading: boolean;
  exportError: any;
  exportData: any;
};

const initialState: InitialState = {
  isLoading: false,
  transits: null,
  error: null,
  filterValues: null,
  isExportLoading: false,
  exportError: null,
  exportData: null,
};

const comparativeAnalysis = createSlice({
  name: 'comparativeAnalysis',
  initialState,
  reducers: {
    requestTransits: (state, payload: PayloadAction<Params>) => {
      state.isLoading = true;
    },
    getTransitsSuccess: (state, { payload }: PayloadAction<any>): void => {
      state.isLoading = false;
      state.transits = payload;
    },
    getTransitsError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.error = payload;
    },
    requestExport: (state, payload: PayloadAction<Params>): void => {
      state.isExportLoading = true;
    },
    exportSuccess: (state, { payload }: PayloadAction<any>): void => {
      state.isExportLoading = false;
      state.exportData = payload;
    },
    exportError: (state, { payload }: PayloadAction<string>): void => {
      state.isExportLoading = false;
      state.exportError = payload;
    },
    clearTransits: (state): void => {
      state.transits = null;
    },
    setFilterValues: (state, { payload }: PayloadAction<Partial<ComparativeAnalysisFilterValues>>): void => {
      state.filterValues = payload;
    },
    clearFilterValues: (state): void => {
      state.filterValues = null;
    },
  },
});

export const {
  requestTransits,
  getTransitsSuccess,
  getTransitsError,
  clearTransits,
  setFilterValues,
  clearFilterValues,
  requestExport,
  exportSuccess,
  exportError,
} = comparativeAnalysis.actions;

export default comparativeAnalysis.reducer;
